import React from 'react';
import { compose } from '@beef/redux';
import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { selectIsRenderHistory } from "../../../../store/slices/search/selectors";
import { CellCard, CommonBlock } from "../CommonBlock";
import { TITLES_BLOCK } from "../../utils/constants";
import { useHistory } from "./hooks/useHistory";
export var _HistoryBlock = function _HistoryBlock() {
  var _useHistory = useHistory(),
    list = _useHistory.list,
    onClear = _useHistory.onClear,
    onClick = _useHistory.onClick;
  if (!list.length) {
    return null;
  }
  return /*#__PURE__*/React.createElement(CommonBlock, {
    isHistory: true,
    title: TITLES_BLOCK.history,
    "data-t-id": "blocks-HistoryBlock"
  }, list.map(function (cell) {
    return /*#__PURE__*/React.createElement(CellCard, {
      item: cell,
      key: cell.title,
      onClear: onClear,
      onClick: onClick
    });
  }));
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: selectIsRenderHistory(state)
  };
};
export var HistoryBlock = compose(connect(mapStateToProps), withRenderFlag)(_HistoryBlock);